export default {
    props: {
        offer: {
            type: Object,
        },
        root: {
            type: Object,
        },
        mobile: {
            type: Boolean,
        },
        animation: {
            type: String,
        },
    },
    // eslint-disable-next-line id-length
    render(h) {
        const dropdownContent = h(
            'div',
            {
                staticClass: 'l-ss-c-offer-dropdown',
                directives: [
                    { name: 'show', value: this.isShowDropdown },
                ],
                attrs: {
                    'data-offer-id': this.offer.id,
                },
                ref: 'dropdown',
            },
            this.child.map(childItem => h(childItem.component, {
                key: childItem.key,
                on: childItem.on,
                props: childItem.bind,
            })),
        );

        if (this.animation) {
            return h(
                'transition',
                {
                    props: {
                        name: this.animation,
                    },
                },
                [dropdownContent],
            );
        }

        return dropdownContent;
    },
    data() {
        return {
            child: [],
            isShowDropdown: false,
            isMouseLeave: false,
            parentOfferEl: null,
            groupedOffersWrapper: null,
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.parentOfferEl = this.root.querySelector(`.l-ss-c-search-results-wrapper .l-ss-c-offer[data-first-offer-id="${this.offer.id}"]`);
            this.groupedOffersWrapper = this.parentOfferEl.closest('.l-ss-c-offers-wrapper-grouped');
            this.processMouseListeners();
        });
    },
    watch: {
        'isShowDropdownChange.value': function (value) {
            this.isShowDropdown = value;
        },
    },
    beforeDestroy() {
        this.parentOfferEl.removeEventListener('mouseenter', this.onMouseEnter);
        this.parentOfferEl.removeEventListener('mouseleave', this.onMouseLeave);
        this.parentOfferEl.removeEventListener('click', this.processMobileClick);
        this.$refs.dropdown.removeEventListener('mouseleave', this.onMouseLeave);
    },
    methods: {
        processMouseListeners() {
            if (this.mobile) {
                this.parentOfferEl.addEventListener('click', this.processMobileClick);
            } else {
                this.parentOfferEl.addEventListener('mouseenter', this.onMouseEnter);
            }

            this.parentOfferEl.addEventListener('mouseleave', this.onMouseLeave);
            this.$refs.dropdown.addEventListener('mouseleave', this.onMouseLeave);
        },

        async onMouseEnter() {
            this.isMouseLeave = false;

            await this.processOfferCartPosition(offerElRect);

            if (this.isMouseLeave) {
                return;
            }

            const offerElRect = this.parentOfferEl.getBoundingClientRect();

            if (this.groupedOffersWrapper) {
                const VISIBLE_OFFSET = 20;
                const groupedOffersWrapperRect = this.groupedOffersWrapper.getBoundingClientRect();

                if (
                    offerElRect.left + VISIBLE_OFFSET < groupedOffersWrapperRect.left ||
                    offerElRect.right - VISIBLE_OFFSET > groupedOffersWrapperRect.right
                ) {
                    return;
                }
            }

            this.isShowDropdown = true;
            this.parentOfferEl.classList.add('l-ss-c-offer-dropdown-show');

            const rootRect = this.root.getBoundingClientRect();
            this.$refs.dropdown.style.top = `${offerElRect.bottom - rootRect.top}px`;
            this.$refs.dropdown.style.left = `${offerElRect.left - rootRect.left}px`;
            this.$refs.dropdown.style.width = `${offerElRect.width}px`;
        },

        onMouseLeave(event) {
            const toElement = event.toElement;
            if (!toElement || !toElement.closest('.l-ss-c-offer-dropdown')) {
                this.isMouseLeave = true;
                this.isShowDropdown = false;
                this.parentOfferEl.classList.remove('l-ss-c-offer-dropdown-show');
            }
        },

        processMobileClick(event) {
            if (this.isShowDropdown) {
                return;
            }

            this.onMouseEnter();

            event.preventDefault();
            event.stopPropagation();
        },

        async processOfferCartPosition() {
            const TIMEOUT_DELAY = 10;

            const checkPosition = (resolve) => {
                const offerRect = this.parentOfferEl.getBoundingClientRect();
                setTimeout(() => {
                    const newOfferRect = this.parentOfferEl.getBoundingClientRect();
                    if (offerRect.left !== newOfferRect.left) {
                        checkPosition(resolve);
                    } else {
                        resolve();
                    }
                }, TIMEOUT_DELAY);
            };

            return new Promise((resolve) => {
                checkPosition(resolve);
            });
        },
    },
};
